import { useAdminAuth } from '../context/AdminAuthContext';
import { useEffect, useState } from 'react';
import { ADMIN_PERMISSIONS, ADMIN_ROLE_PERMISSIONS } from '../constants/permissions';

export const useAdminPermissions = () => {
  const { admin } = useAdminAuth();
  const [rolePermissions, setRolePermissions] = useState(ADMIN_ROLE_PERMISSIONS);

  useEffect(() => {
    // In the future we can fetch company-specific admin role permissions here
    setRolePermissions(ADMIN_ROLE_PERMISSIONS);
  }, []);

  const hasPermission = (permission) => {
    if (!admin) return false;

    // Full admin access
    if (admin?.role === 'admin' || admin?.role === 'super-admin' || admin?.permissions?.includes('all')) {
      return true;
    }

    // Individual permissions override role perms
    if (Array.isArray(admin?.permissions) && admin.permissions.includes(permission)) {
      return true;
    }

    const role = admin?.role || 'support';
    const allowed = rolePermissions[role] || [];
    return allowed.includes(permission);
  };

  const hasAllPermissions = (permissions) => permissions.every(p => hasPermission(p));
  const hasAnyPermission = (permissions) => permissions.some(p => hasPermission(p));

  return {
    hasPermission,
    hasAllPermissions,
    hasAnyPermission,
    ADMIN_PERMISSIONS
  };
};
